"use client";

import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {assetPath} from "@/shared/utils/asset-path";

import {ButtonBase} from "./button-base";

import "./styles/show-more-show-less-button.scss";

export interface ShowMoreShowLessButtonProps {
    showReadLessButton: boolean;
    hasMore: boolean;
    onShowLess: () => void;
    onShowMore: () => void;
}

const ARROW_ICON = assetPath("/images/icons/arrow-black-down.svg");

export function ShowMoreShowLessButton({showReadLessButton, hasMore, onShowLess, onShowMore}: ShowMoreShowLessButtonProps): JSX.Element | null {
    const {t} = useTranslation("common");

    if (!hasMore && !showReadLessButton) {
        return null;
    }

    if (showReadLessButton) {
        return (
            <ButtonBase variant="secondary-outline" size="xs-s" width="fit" onClick={() => void onShowLess()}>
                <SmartImage
                    src={ARROW_ICON}
                    alt=""
                    width={12}
                    height={10}
                    className="show-more-show-less-button__arrow show-more-show-less-button__arrow--up"
                />
                {t("showLess")}
            </ButtonBase>
        );
    }

    return (
        <ButtonBase variant="secondary-outline" size="xs-s" width="fit" onClick={onShowMore}>
            {t("seeMore")}
            <SmartImage src={ARROW_ICON} alt="" width={12} height={10} className="show-more-show-less-button__arrow" />
        </ButtonBase>
    );
}
